<template>
  <div>
    城市:
    <el-button
      v-for="(eachCity, index) in cities"
      v-bind:key="index"
      :disabled="eachCity.id === city"
      :type="eachCity.id === city ? 'primary' : ''"
      class="city"
      @click.prevent="goToSubdomain(eachCity.id)"
    >
      <span>{{ eachCity.name }}</span>
    </el-button>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "cities",
  metaInfo: {
    title: "城市"
  },
  props: {
    city: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(["cities"])
  },
  methods: {
    ...mapMutations(["setCities", "goToSubdomain"])
  },
  // set the layout to topic when it's mounted.
  mounted: function() {
    this.$axios.get("/cities").then(res => {
      this.setCities(res.data);
    });
  }
};
</script>
